<template>
  <main class="view-vas-subscription remove-body-top-padding d-flex flex-column text-dark">
    <article class="d-flex flex-xxs-column flex-md-row align-items-center justify-content-xxs-start justify-content-md-end vh-100">
      <SubscriptionLoading v-if="isloading" :is-loading="true" />
      <section class="bubble-information d-flex flex-column align-self-xxs-center align-self-sm-start mx-5" :class="{'no-animation': routeName=='vasSubscription'}">
        <p class="text-white information-text m-0" :class="{'description-info': routeName == 'vasSubscription'}" v-html="$t('security.vasSubscription.subInformation')" />
      </section>
      <flexMobile class="activation-form d-xxs-none d-sm-flex flex-column" :mobile-content="MobileContent" />
      <section class="flex-activation-form d-flex flex-column d-xxs-flex d-sm-none">
        <vasSubscriptionForm />
      </section>
    </article>

    <footer class="circles position-fixed d-flex">
      <div class="circle green d-xxs-none d-md-block" :class="{'no-animation': routeName == 'vasSubscription'}" />
      <div class="circle yellow" :class="{'no-animation': routeName == 'vasSubscription'}" />
      <div class="circle blue" :class="{'no-animation': routeName == 'vasSubscription'}" />
      <div class="circle red d-xxs-none d-md-block" :class="{'no-animation': routeName == 'vasSubscription'}" />
    </footer>
  </main>
</template>

<script>
import flexMobile from '@/components/FlexMobile.vue'
import SubscriptionLoading from '@/components/SubscriptionLoading.vue'
import { mapActions, mapGetters } from 'vuex'
import vasSubscriptionForm from '@/components/VasSubscriptionForm.vue'

export default {
  name: 'VasSubscription',
  components: {
    flexMobile,
    SubscriptionLoading,
    vasSubscriptionForm
  },
  computed: {
    ...mapGetters({
      routeName: 'order/routeName'
    })
  },
  data () {
    return {
      isloading: false,
      pinIsNotValid: false,
      activationInfo: '',
      MobileContent: vasSubscriptionForm
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
